import {isCustomizationEnabled} from '@github-ui/ahp-session-client/customization-enablement'
import type {ChildCustomization, SessionState} from '@microsoft/agent-host-protocol'

export function getStartingMcpServerNames(customizations: SessionState['customizations']): string[] {
  const servers = (customizations ?? []).flatMap<ChildCustomization>(customization => {
    if (!isCustomizationEnabled(customization)) return []
    if (customization.type === 'mcpServer') return [customization]
    if (customization.load?.kind === 'error') return []
    return customization.children ?? []
  })
  return servers
    .filter(
      server =>
        server.type === 'mcpServer' && server.enablement?.[0]?.enabled !== false && server.state.kind === 'starting',
    )
    .map(server => server.name?.trim() || 'a tool server')
}
